'use strict';

jQuery.noConflict();

jQuery( document ).ready( function( $ ) {

	Yacc.configure({
		culture: 'it',
		cookiePageUrl: '/privacy-e-cookie',
	});

	var siteInit = {

		DOMready: function() {

			if ( $('.slider--primary').length > 0 ) {
				siteInit.carousel();
			}

			if ( $('[rel="gallery"]').length > 0 ) {
				siteInit.modalGallery();
			}

			if ( $('[href$=".jpg"], [href$=".png"], [href$=".gif"]').length > 0 ) {
				siteInit.modal();
			}

		},


		// Carousel

		carousel: function() {

			$(".slider--primary").slick({
				dots: false,
				speed: 500,
				slidesToScroll: 1,
				arrows:false,
				autoplay: true,
				fade: true,
				cssEase: 'linear'
			});

		},


		// Modal

		modal: function() {

			$('[href$=".jpg"], [href$=".png"], [href$=".gif"]').colorbox({
				transition: 'elastic',
				speed: 400,
				opacity: 0.8,
				itemsnitialWidth: 50,
				initialHeight: 50,
				maxWidth: '90%',
				maxHeight: '90%',
			});

		}


	};

	siteInit.DOMready();

});
